export default "__VITE_ASSET__dcc3181b__"